import { render, staticRenderFns } from "./registerDialog.vue?vue&type=template&id=f8850660&scoped=true"
import script from "./registerDialog.vue?vue&type=script&lang=js"
export * from "./registerDialog.vue?vue&type=script&lang=js"
import style0 from "./registerDialog.vue?vue&type=style&index=0&id=f8850660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8850660",
  null
  
)

export default component.exports